module.exports = __webpack_public_path__ + "images/169_320.jpg";